<script setup>
/* Store */
import { useGlobalStore } from '../store/global.js';

/* Components */
import Table from '../components/Table.vue';

/* Init store */
const globalStore = useGlobalStore();

/* Props */
const props = defineProps({
  specs: {
    type: Object,
    default: () => {},
  },
  maxProducts: {
    type: Number,
    default: 2,
  },
});

/* Checks a spec group for differences */
const checkForDifferences = (specs) => !specs.every((spec) => spec.differences === false);

/* Show spec group */
const expandSpecGroup = (specs) => (globalStore.getShowDifferences ? checkForDifferences(specs) : true);

/* Show spec */
const showSpec = (differences) => (globalStore.getShowDifferences ? differences : true);
</script>

<template>
  <div class="app-body">
    <div class="container-inner">
      <div
        v-for="specGroup in props.specs?.specGroups"
        :key="specGroup?.specGroupKey"
      >
        <g-collapsible-region
          :data-test="`${specGroup?.specGroupKey}`"
          :expanded="expandSpecGroup(specGroup?.specs)"
        >
          <!-- eslint-disable vue/no-deprecated-slot-attribute -->
          <div
            slot="heading"
            class="heading-wrapper"
          >
            <g-heading
              text-align="left"
              size="2"
              :dataTestId="{
                host: 'product-compare-spec-group-host',
              }"
            >
              <h2 v-html="specGroup?.specGroupKeyDisplayName" />
            </g-heading>
          </div>
          <div slot="body">
            <!-- eslint-enable vue/no-deprecated-slot-attribute -->
            <div
              v-for="spec in specGroup?.specs"
              :key="spec?.specKey"
            >
              <Table
                v-if="showSpec(spec?.differences)"
                :spec-name="spec?.specDisplayName"
                :spec-key="spec?.specKey"
                :spec-list="spec?.values"
                :max-products="props?.maxProducts"
              />
            </div>
          </div>
        </g-collapsible-region>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.g__collapsible-region__heading__icon) {
  margin-left: 0.3rem;
  padding: 0 0.5rem;

  @include breakpoint('xs') {
    padding: 0;
  }
}

.heading-wrapper {
  flex-grow: 1;

  @include breakpoint('xs') {
    flex-grow: 0;
  }

  :deep(.g__heading) {

    h2 {
      margin: 1.5rem 0;
      text-transform: uppercase;
      padding: 0.5rem;
    }
  }
}
</style>
